/** ProjectSettings/ProjectSettings.asset: `m_ActiveColorSpace: 0`. */
export const AXIE_UNITY_ACTIVE_COLOR_SPACE = 0 as const;
export const AXIE_UNITY_COLOR_SPACE = 'gamma' as const;
/** Browser transport validated against the Unity PNG oracle. */
export const AXIE_THREE_SHADER_WORKING_COLOR_SPACE = 'linear-srgb' as const;
